import React from 'react';
import { useTranslation } from 'next-i18next';
import { SettingColumn } from '@/shared/components/settingForm/SettingColumn';
import { SettingSection } from '@/shared/components/settingForm/SettingSection';
import { useCountryCode } from '@/shared/hooks';
import { AnswerRevealModeField, ToggleAiTranslationField, ToggleAllowField, ToggleNextQuizsetField, TogglePublicField } from '@/views/build/form';
import { AiTutorSetting } from '../setting/AiTutorSetting';
import { LearningMaterialSetting } from '../setting/LearningMaterialSetting';
import { MapAndCategoryInfoSection } from './SectionBasicInfo/MapAndCategoryInfoSection';
import { BuildProFeatureCoachmarkProvider } from './BuildProFeatureCoachmark';
export const BuildStepSettings = () => {
  const {
    isKR
  } = useCountryCode();
  const {
    t
  } = useTranslation(['build']);
  return <BuildProFeatureCoachmarkProvider data-sentry-element="BuildProFeatureCoachmarkProvider" data-sentry-component="BuildStepSettings" data-sentry-source-file="BuildStepSettings.tsx">
      <SettingColumn data-sentry-element="SettingColumn" data-sentry-source-file="BuildStepSettings.tsx">
        <SettingSection title={t('build:settings.basicInfo')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
          <MapAndCategoryInfoSection data-sentry-element="MapAndCategoryInfoSection" data-sentry-source-file="BuildStepSettings.tsx" />
        </SettingSection>

        <SettingSection title={t('build:settings.quizSetting')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
          <ToggleAllowField data-sentry-element="ToggleAllowField" data-sentry-source-file="BuildStepSettings.tsx" />
          <AnswerRevealModeField data-sentry-element="AnswerRevealModeField" data-sentry-source-file="BuildStepSettings.tsx" />
        </SettingSection>

        <SettingSection title={t('build:settings.learningTool')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
          {isKR && <AiTutorSetting />}
          <ToggleAiTranslationField data-sentry-element="ToggleAiTranslationField" data-sentry-source-file="BuildStepSettings.tsx" />
          <LearningMaterialSetting data-sentry-element="LearningMaterialSetting" data-sentry-source-file="BuildStepSettings.tsx" />
        </SettingSection>

        <SettingSection title={t('build:settings.advanced')} data-sentry-element="SettingSection" data-sentry-source-file="BuildStepSettings.tsx">
          <ToggleNextQuizsetField data-sentry-element="ToggleNextQuizsetField" data-sentry-source-file="BuildStepSettings.tsx" />
          <TogglePublicField data-sentry-element="TogglePublicField" data-sentry-source-file="BuildStepSettings.tsx" />
        </SettingSection>
      </SettingColumn>
    </BuildProFeatureCoachmarkProvider>;
};